import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ImportantLinkData } from '../models/important-links/important-link-data';

@Injectable({ providedIn: 'root' })
export class ImportantLinksService {
  constructor(private http: HttpClient) {}

  load(): Observable<ImportantLinkData[]> {
    return this.http.get<ImportantLinkData[]>('assets/configs/important-links.json');
  }
}